/**
 * What the page for lawyers tells search engines — ONE copy, read by today's page (src/pages/ForLawyers.tsx) and
 * its rebuild in the new design (src/design/pavilion/pages/for-lawyers/) through one head component,
 * src/components/ForLawyersHead.tsx (PV4, design record §7b).
 *
 * This page has always written its head with react-helmet-async directly rather than through SeoHead: its own title,
 * description, keywords, canonical and three social-card fields, and no structured data. That block is kept exactly
 * as it was, because this is prest0.ai's search listing and a rebuild changes how a page looks, never what it tells a
 * crawler. Read by the guest chat's knowledge source for "/for-lawyers": each `title:` / `description:` stays on one
 * line.
 */
export const FOR_LAWYERS_CANONICAL_URL = 'https://prest0.ai/for-lawyers';

export const FOR_LAWYERS_SEO = {
  title: 'AI for Solo & Small Firm Lawyers | prest0',
  description: 'An AI associate for solo practitioners and boutique law firms. Automate document drafting, bilingual client communications, and deep legal research.',
  keywords: 'AI for lawyers, solo practitioner AI, boutique law firm AI, legal research AI, automated drafting for lawyers',
  canonicalUrl: FOR_LAWYERS_CANONICAL_URL,
  ogTitle: 'AI for Solo & Small Firm Lawyers | prest0',
  ogDescription: 'An AI associate for solo practitioners and boutique law firms.',
} as const;
